var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin registration-page"},[_c('change-password-form',{attrs:{"submit":_vm.changePassword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }